export interface NewsArticle {
  id: string
  title: string
  slug: string
  excerpt: string
  content: string
  author: string
  authorTitle: string
  publishedAt: string
  category: string
  readTime: string
  featured: boolean
  projectCode?: string
  securityLevel?: string
}

export const newsArticles: NewsArticle[] = [
  {
    id: 'nexus-global-expands-operations-asia-pacific',
    title: 'Nexus Global Expands Operations to Asia-Pacific Region',
    slug: 'nexus-global-expands-operations-asia-pacific',
    excerpt: 'We are excited to announce the opening of our new regional headquarters in Singapore, marking our strategic expansion into the Asia-Pacific market.',
    content: `Nexus Global Solutions today confirmed the expansion of its operations into the Asia-Pacific region, anchored by a new regional presence in Singapore. The move builds on two years of growth in the region and reinforces the company's commitment to serving clients across emerging markets.

"Singapore is the natural gateway for our Asia-Pacific ambitions," said Dr. Alexandra Chen, Chief Executive Officer. "Having partners and people on the ground lets us move faster for our clients."

To support the expansion, Nexus has deepened its relationship with Singapore-based Silk Road Logistics, which coordinates freight and supply-chain operations for regional clients. The company expects to formalize additional local hires through the remainder of the year.

Reporting for the Valdoria Business Journal, correspondent Dana Whitfield noted that the expansion "positions Nexus among a small group of Valdoria firms making a serious push into Southeast Asia."`,
    author: 'Dr. Alexandra Chen',
    authorTitle: 'Chief Executive Officer',
    publishedAt: '2024-03-15',
    category: 'Company News',
    readTime: '3 min read',
    featured: true
  },
  {
    id: 'strategic-partnership-astoria-energy-group',
    title: 'Strategic Partnership with Astoria Energy Group',
    slug: 'strategic-partnership-astoria-energy-group',
    excerpt: 'Nexus Global announces a landmark partnership with Astoria Energy Group to facilitate renewable energy investments across emerging markets.',
    content: `Nexus Global Solutions has entered into a strategic alliance with Astoria Energy Group to facilitate renewable energy investments across emerging markets. The joint venture pairs Nexus's market-entry expertise with Astoria's deep experience in clean-energy project finance.

"Sustainable infrastructure is where international capital is heading, and our clients want a trusted guide," said Elena Volkov, Chief Strategy Officer. "This partnership gives them one."

The alliance will initially focus on solar and wind projects in Southeast Asia and Latin America, with Robert Martinez, International Markets Director, leading partnership delivery. Financial structuring for the venture is being overseen by the Nexus finance team, following the firm's 2022 Series C round led by Harbor Point Capital.`,
    author: 'Elena Volkov',
    authorTitle: 'Chief Strategy Officer',
    publishedAt: '2024-03-10',
    category: 'Partnerships',
    readTime: '5 min read',
    featured: true
  },
  {
    id: 'harbor-point-capital-series-c',
    title: 'Nexus Global Closes $45M Series C Led by Harbor Point Capital',
    slug: 'harbor-point-capital-series-c',
    excerpt: 'Nexus Global Solutions has closed a $45 million Series C financing round led by Harbor Point Capital to accelerate its international expansion.',
    content: `Nexus Global Solutions announced today that it has closed a $45 million Series C financing round led by Harbor Point Capital, with participation from existing backers. The capital will fund the firm's expansion into new international markets and continued investment in its technology platform.

"Harbor Point shares our conviction that the next decade of growth belongs to firms that can operate seamlessly across borders," said David Kim, Chief Financial Officer, who led the round. "Their support lets us invest with confidence."

A partner at Harbor Point Capital will take an observer seat on the Nexus board. The round was first reported by Dana Whitfield of the Valdoria Business Journal, who wrote that "the raise cements Nexus as one of Valdoria's best-funded consulting exports."

The Series C follows the company's 2020 regional expansion and sets the stage for further growth across the Asia-Pacific region.`,
    author: 'David Kim',
    authorTitle: 'Chief Financial Officer',
    publishedAt: '2022-11-08',
    category: 'Financial News',
    readTime: '4 min read',
    featured: false
  },
  {
    id: 'global-markets-summit-2023',
    title: 'Nexus Leaders Take the Stage at Global Markets Summit 2023',
    slug: 'global-markets-summit-2023',
    excerpt: 'CEO Dr. Alexandra Chen delivered the keynote and CSO Elena Volkov joined a headline panel at the Global Markets Summit 2023.',
    content: `Two Nexus Global executives featured prominently at the Global Markets Summit 2023, the annual gathering hosted by the International Business Consultants Association (IBCA).

CEO Dr. Alexandra Chen delivered the event's opening keynote on the future of cross-border investment, while Chief Strategy Officer Elena Volkov joined a headline panel on regulatory risk in emerging markets. The two shared the main stage during the summit's closing session.

"Forums like the Global Markets Summit are where the next wave of partnerships begins," said Dr. Chen. Advisory board member Maria Santos, a former WTO director, co-chaired the summit's program committee.

Coverage of the executives' appearances was carried by the Valdoria Business Journal, whose correspondent Dana Whitfield described the keynote as "a confident statement of intent from a firm punching above its weight."`,
    author: 'Michael Rodriguez',
    authorTitle: 'Chief Operating Officer',
    publishedAt: '2023-09-22',
    category: 'Events',
    readTime: '4 min read',
    featured: false
  },
  {
    id: 'silk-road-logistics-singapore-partnership',
    title: 'Nexus Partners with Silk Road Logistics for Singapore Operations',
    slug: 'silk-road-logistics-singapore-partnership',
    excerpt: 'Nexus Global has named Singapore-based Silk Road Logistics as its regional logistics partner to support Asia-Pacific supply-chain operations.',
    content: `Nexus Global Solutions has named Silk Road Logistics as its regional logistics partner for the Asia-Pacific market. The Singapore-based firm will coordinate freight forwarding and supply-chain services for Nexus clients across Southeast Asia.

"As our regional footprint grows, we needed a partner who knows the ground truth of Singapore and the wider region," said Robert Martinez, International Markets Director. "Silk Road Logistics is exactly that."

The partnership reinforces the strengthening ties between Nexus and Singapore, where the firm has been steadily building its presence. Terms of the arrangement were not disclosed.

The Valdoria Business Journal's Dana Whitfield reported that the tie-up "quietly signals how serious Nexus has become about Singapore."`,
    author: 'Robert Martinez',
    authorTitle: 'International Markets Director',
    publishedAt: '2023-06-14',
    category: 'Partnerships',
    readTime: '3 min read',
    featured: false
  },
  {
    id: 'q1-2024-financial-results',
    title: 'Q1 2024 Financial Results: Record Growth Continues',
    slug: 'q1-2024-financial-results',
    excerpt: 'Nexus Global reports exceptional Q1 2024 results with 35% revenue growth and expansion into three new international markets.',
    content: `Nexus Global Solutions reported record first-quarter results for 2024, with revenue up 35% year over year and expansion into three new international markets.

"These results reflect disciplined execution and the trust our clients place in us," said David Kim, Chief Financial Officer. "The capital from our 2022 Series C, led by Harbor Point Capital, continues to fund high-return growth."

Growth was strongest in the Asia-Pacific region, supported by the firm's new logistics partnership with Silk Road Logistics. Management reaffirmed full-year guidance and signaled continued hiring across consulting and technology teams.`,
    author: 'David Kim',
    authorTitle: 'Chief Financial Officer',
    publishedAt: '2024-03-05',
    category: 'Financial News',
    readTime: '4 min read',
    featured: false
  },
  {
    id: 'international-trade-summit-valdoria',
    title: 'Nexus Global Hosts International Trade Summit in Valdoria',
    slug: 'international-trade-summit-valdoria',
    excerpt: 'Over 200 international business leaders gathered in Valdoria City for our annual trade summit, discussing emerging market opportunities.',
    content: `More than 200 international business leaders gathered in Valdoria City for the annual Nexus Global trade summit, an event focused on emerging-market opportunities and cross-border partnerships.

"Bringing this community together in Valdoria is a point of real pride for us," said Michael Rodriguez, Chief Operating Officer, who opened the summit. Sessions covered regulatory trends, supply-chain resilience, and the outlook for foreign investment.

Several attendees noted the summit's growing profile since Nexus executives appeared at the IBCA's Global Markets Summit 2023. Local coverage was provided by the Valdoria Business Journal.`,
    author: 'Michael Rodriguez',
    authorTitle: 'Chief Operating Officer',
    publishedAt: '2024-02-28',
    category: 'Events',
    readTime: '6 min read',
    featured: false
  },
  {
    id: 'new-market-entry-framework',
    title: 'Introducing Our New Market Entry Framework',
    slug: 'new-market-entry-framework',
    excerpt: 'Our proprietary NEXUS Framework™ provides clients with a systematic approach to international market expansion and risk assessment.',
    content: `Nexus Global Solutions has unveiled the NEXUS Framework™, a proprietary methodology that gives clients a systematic approach to international market expansion and risk assessment.

The framework distills lessons from hundreds of client engagements into a repeatable process covering feasibility analysis, regulatory review, partner identification, and entry planning. Senior consultant Scott Johnson led the framework's development.

"Clients kept asking us to package the way we think," said Johnson. "The NEXUS Framework does exactly that." The methodology is already being applied across active engagements in the Asia-Pacific region.`,
    author: 'Scott Johnson',
    authorTitle: 'Senior Business Consultant',
    publishedAt: '2024-02-20',
    category: 'Industry Insights',
    readTime: '7 min read',
    featured: false
  },
  {
    id: 'sustainability-initiative-launch',
    title: 'Nexus Global Launches Sustainability Initiative',
    slug: 'sustainability-initiative-launch',
    excerpt: 'We are committed to promoting sustainable business practices and environmental responsibility across all our international partnerships.',
    content: `Nexus Global Solutions has launched a company-wide sustainability initiative aimed at embedding environmental responsibility across its international partnerships.

"Sustainability is now a core criterion in how we advise clients and choose partners," said Maria Garcia, Legal Counsel, who leads the initiative's governance workstream. The program includes commitments on responsible sourcing, partner due diligence, and transparent reporting.

The initiative complements the firm's alliance with Astoria Energy Group on renewable-energy investment and reflects growing client demand for credible ESG guidance.`,
    author: 'Maria Garcia',
    authorTitle: 'Legal Counsel',
    publishedAt: '2024-02-15',
    category: 'Corporate Social Responsibility',
    readTime: '4 min read',
    featured: false
  },
  // ============================================================
  // OSINT EASTER EGGS - Articles with hidden messages and clues
  // ============================================================
  {
    id: 'internal-restructuring-announcement',
    title: 'Internal Restructuring Announcement: New Leadership Roles',
    slug: 'internal-restructuring-announcement',
    // CLUE: First letters of each sentence spell "SECRETS HIDE IN PLAIN SIGHT"
    excerpt: 'Significant changes are coming to our organizational structure. Executive leadership has approved new departmental roles. Creating opportunities for growth remains our priority. Redefining excellence through strategic initiatives. Every team member will benefit from these changes. Transparency in communication is our commitment. Several new positions will be announced soon.',
    content: `Significant changes are coming to our organizational structure, as we adapt to the evolving global business landscape.

Executive leadership has approved new departmental roles that will enhance our service delivery capabilities.

Creating opportunities for growth remains our priority as we expand into new markets.

Redefining excellence through strategic initiatives is at the heart of this restructuring.

Every team member will benefit from these changes, with improved career pathways and development opportunities.

Transparency in communication is our commitment to all stakeholders during this transition.

Several new positions will be announced soon, including roles in our expanded technology division.

Holding ourselves accountable to the highest standards remains paramount.

Internal feedback has been invaluable in shaping these decisions.

Dedicated teams will manage the transition to ensure business continuity.

Excellence in service delivery will not be compromised during this period.

International operations will see particular focus in this restructuring.

New regional offices may be established to support our growing client base.

Partnerships with key stakeholders will be strengthened.

Leadership remains committed to our core values throughout this process.

All employees are encouraged to reach out with questions.

Information sessions will be scheduled for each department.

Next steps will be communicated via internal channels.

Sincere thanks to everyone for their continued dedication.

Individual meetings can be requested through HR.

Growth and success are our shared goals.

Here's to a bright future for Nexus Global.

Together, we will achieve greatness.`,
    author: 'Dr. Alexandra Chen',
    authorTitle: 'Chief Executive Officer',
    publishedAt: '2024-01-20',
    category: 'Company News',
    readTime: '5 min read',
    featured: false
  },
  {
    id: 'confidential-project-update',
    title: 'Project Lighthouse: Confidential Client Success Story',
    slug: 'confidential-project-update',
    // CLUE: References to classified information and hidden project codes
    excerpt: 'Our team successfully completed a high-profile engagement under strict confidentiality. While details remain classified, we can share that Project Lighthouse exceeded all performance metrics.',
    content: `Our team successfully completed a high-profile engagement under strict confidentiality. While details remain classified, we can share that Project Lighthouse exceeded all performance metrics.

The engagement was led out of a special-projects team and coordinated with our (not yet publicly announced) regional operations. Further details are restricted to stakeholders with the appropriate clearance.`,
    author: 'Victor Petrov',
    authorTitle: 'Senior Consultant - Special Projects',
    // CLUE: Author doesn't exist in the main employee list
    publishedAt: '2024-01-15',
    category: 'Case Studies',
    readTime: '3 min read',
    featured: false,
    // Hidden metadata for OSINT practice
    projectCode: 'NGS-LH-2024-CLASSIFIED',
    securityLevel: 'CONFIDENTIAL'
  },
  {
    id: 'whistleblower-policy-update',
    title: 'Updated Corporate Whistleblower Protection Policy',
    slug: 'whistleblower-policy-update',
    // CLUE: Contains hints about internal reporting mechanisms
    excerpt: 'Nexus Global has strengthened its whistleblower protection framework. Anonymous reporting channels are now available at ethics@nexusglobal.com and through our secure portal at reporting.nexusglobal.internal.',
    content: `We take corporate governance seriously at Nexus Global. Our updated whistleblower policy ensures that all employees and stakeholders can report concerns without fear of retaliation.

Anonymous reporting options include:
- Email: ethics@nexusglobal.com
- Internal portal: reporting.nexusglobal.internal
- Hotline: +1-555-ETHICS-1 (384-4271)
- External counsel: whistleblower@nexuslegal.com

All reports are reviewed by our Internal Affairs department under the supervision of Sarah Blackwood, Director of Internal Affairs.

For sensitive matters involving executive leadership, reports can be submitted directly to the Board of Directors via board.confidential@nexusglobal.com

Document retention for whistleblower cases: 7 years
Investigation timeline: 30-90 days
External audit frequency: Annual`,
    author: 'Sarah Blackwood',
    authorTitle: 'Director of Internal Affairs',
    publishedAt: '2024-01-10',
    category: 'Corporate Governance',
    readTime: '4 min read',
    featured: false
  },
  {
    id: 'data-breach-incident-report',
    title: 'Security Incident Response: Lessons Learned',
    slug: 'data-breach-incident-report',
    // CLUE: References to security incident and response procedures
    excerpt: 'Following a minor security incident in Q4 2023, our IT team has implemented enhanced security measures. No client data was compromised, but we believe in full transparency about our security practices.',
    content: `In November 2023, our security team detected unusual activity on one of our development servers. The incident was contained within 4 hours and a thorough investigation was conducted.

Key findings:
- Attack vector: Compromised third-party dependency
- Systems affected: staging.nexusglobal-consulting.com
- Data exposed: None (staging environment uses synthetic data)
- Credentials at risk: Development API keys (rotated immediately)

Response actions:
- Incident reported to relevant authorities
- All API keys and credentials rotated
- Enhanced monitoring implemented
- Security audit by CyberShield Consultants completed

For questions about our security practices, contact:
- Security team: security@nexusglobal-consulting.com
- CISO: j.chen@nexusglobal-consulting.com
- Incident hotline: +1-555-0199 ext. 9911

Full incident report available to stakeholders upon request (reference: SEC-INC-2023-Q4-001)`,
    author: 'James Chen',
    authorTitle: 'IT Security Administrator',
    publishedAt: '2024-01-05',
    category: 'Security',
    readTime: '6 min read',
    featured: false
  }
]
